export default __webpack_public_path__ + "static/media/spr-lesson-builder-dark.b21a5d52.jpg";